import { render, staticRenderFns } from "./punch-result.vue?vue&type=template&id=9162d464&scoped=true&"
import script from "./punch-result.vue?vue&type=script&lang=js&"
export * from "./punch-result.vue?vue&type=script&lang=js&"
import style0 from "./punch-result.vue?vue&type=style&index=0&id=9162d464&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9162d464",
  null
  
)

export default component.exports